// @ts-nocheck


import { fetchRequest } from './index';

import CommonApi from './../commonApi';

import { convertFromRubToKop, convertFromKopToRub } from '../pure/unitConversions';
import { convertDataFromServer as convertDataFromServerAssignment } from './assignmentLimit';

export const convertDataToServer = (
сontractVehicleBudget) => (
{
  ...сontractVehicleBudget,
  carServicesCost: convertFromRubToKop(сontractVehicleBudget.carServicesCost),
  otherVehicleServicesCost: convertFromRubToKop(
    сontractVehicleBudget.otherVehicleServicesCost
  ),
  acsVehicleServicesCost: convertFromRubToKop(
    сontractVehicleBudget.acsVehicleServicesCost
  ),
  cargoServicesCost: convertFromRubToKop(
    сontractVehicleBudget.cargoServicesCost
  ),
  mechanismServicesCost: convertFromRubToKop(
    сontractVehicleBudget.mechanismServicesCost
  ),
  assignmentLimits: сontractVehicleBudget.assignmentLimits ?
  [
  ...сontractVehicleBudget.assignmentLimits.map((assignmentLimit) =>
  convertDataFromServerAssignment(assignmentLimit)
  )] :

  undefined
});

export const convertDataFromServer = (
сontractVehicleBudget) => (
{
  ...сontractVehicleBudget,
  carServicesCost: convertFromKopToRub(сontractVehicleBudget.carServicesCost),
  otherVehicleServicesCost: convertFromKopToRub(
    сontractVehicleBudget.otherVehicleServicesCost
  ),
  acsVehicleServicesCost: convertFromKopToRub(
    сontractVehicleBudget.acsVehicleServicesCost
  ),
  cargoServicesCost: convertFromKopToRub(
    сontractVehicleBudget.cargoServicesCost
  ),
  mechanismServicesCost: convertFromKopToRub(
    сontractVehicleBudget.mechanismServicesCost
  )
});

export const getExpenseDirectionBudget = async (
contractVehicleBudgetId,
type) =>
{
  const data = await fetchRequest.get(
    `/${basedUrl}/getExpenseDirectionBudget/${contractVehicleBudgetId}/${type}`
  );
  if (data) return data;
  throw new Error(
    `Не удалось получить расшифровки бюджету по типа направления расходов`
  );
};

export const getByContractVehiclePlan = async (
id) =>
{
  const contractVehicleBudget = await fetchRequest.get(
    `/${basedUrl}/getByContractVehiclePlan/${id}`
  );
  if (contractVehicleBudget)
  return convertDataFromServer(contractVehicleBudget);
  throw new Error(`Не удалось сменить статус`);
};

const basedUrl = 'contractVehicleBudget';
const contractVehicleBudget = new CommonApi(
  basedUrl,
  'бюджет НТС',
  convertDataToServer,
  convertDataFromServer
);

export default {
  ...contractVehicleBudget,
  getByContractVehiclePlan,
  getExpenseDirectionBudget
};
